module.exports = __webpack_public_path__ + "img/i3.f62a99cc.jpg";